// removed by extract-text-webpack-plugin
module.exports = {"inner":"src-pages-about----index-module---inner---2FmvY"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/index.module.css
// module id = 327
// module chunks = 10991734084388